import { AbstractControl } from '@angular/forms';

export const requireMatchValidator = (control: AbstractControl) => {
  const selection: any = control.value;
  if (typeof selection === 'string' && selection !== '') {
    return { noMatch: true };
  }

  return null;
};
